import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { SocialLinksType } from '../../types';
import { Box } from '@material-ui/core';
import {
    Facebook as FacebookIcon,
    Twitter as TwitterIcon,
    LinkedIn as LinkedInIcon,
    Instagram as InstagramIcon,
    YouTube as YouTubeIcon,
} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex'
    },
    logo: {
        height: '80px',
        // Mobile height
        [theme.breakpoints.down('sm')]: {
            height: '50px',
        }
    },
    icon: ({ iconColor }: CSSProps) => {
        let color = theme.palette.text.primary;

        if (iconColor) {
            color = iconColor;
        }

        return {
            color,
            margin: theme.spacing(1),
            // Mobile height
            [theme.breakpoints.down('sm')]: {
                margin: theme.spacing(0.5),
                fontSize: '1rem',
            }
        };
    }
}));

interface CSSProps {
    iconColor?: string;
}

interface Props {
    socialLinks: SocialLinksType;
    iconColor?: string;
}

const SocialLinks = ({ socialLinks, iconColor }: Props): JSX.Element => {
    const classes = useStyles({ iconColor });

    if (socialLinks) {
        const { facebook, twitter, linkedin, instagram, youtube } = socialLinks;
        return (
            <Box className={classes.container}>
                {
                    facebook && (
                        <a href={facebook} target="_blank" rel="noreferrer">
                            <FacebookIcon className={classes.icon}/>
                        </a>
                    )
                }
                {
                    twitter && (
                        <a href={twitter} target="_blank" rel="noreferrer">
                            <TwitterIcon className={classes.icon}/>
                        </a>
                    )
                }
                {
                    linkedin && (
                        <a href={linkedin} target="_blank" rel="noreferrer">
                            <LinkedInIcon className={classes.icon}/>
                        </a>
                    )
                }
                {
                    instagram && (
                        <a href={instagram} target="_blank" rel="noreferrer">
                            <InstagramIcon className={classes.icon}/>
                        </a>
                    )
                }
                {
                    youtube && (
                        <a href={youtube} target="_blank" rel="noreferrer">
                            <YouTubeIcon className={classes.icon}/>
                        </a>
                    )
                }
            </Box>
        );
    }

    return <></>;
};

export default SocialLinks;
